import { Text, TextProps } from '@/components/atoms/text';
import Card from '../Card';

export interface CountdownTimerProps {
  label?: string;
  timeComponents: {
    days: string;
    mins: string;
    hours: string;
    secs: string;
  };
  isTimerVisible?: boolean;
}

const mutualTextProps: Partial<TextProps> = {
  variant: 'body-l',
};

export const CountdownTimer = ({
  label,
  timeComponents,
  isTimerVisible = true,
}: CountdownTimerProps) => (
  <div className='flex flex-row gap-2'>
    <span>
      {!!label && label}
      {isTimerVisible && !!label && <span> -</span>}
    </span>
    {isTimerVisible && (
      <Card
        data-hidden='false'
        classNames={{
          root: 'dark:bg-brand-600 bg-brand-600 flex flex-row border-none gap-2 py-1 px-3 dark font-mono',
        }}
      >
        <Text {...mutualTextProps}> {timeComponents.days} d</Text>
        <Text {...mutualTextProps}>:</Text>
        <Text {...mutualTextProps}> {timeComponents.hours} h</Text>
        <Text {...mutualTextProps}>:</Text>
        <Text {...mutualTextProps}> {timeComponents.mins} m</Text>
        <Text {...mutualTextProps}>:</Text>
        <Text {...mutualTextProps}> {timeComponents.secs} s</Text>
      </Card>
    )}
  </div>
);
